import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { truncateAddress } from '../utils/walletAuth';
import { useWallet } from '../context/WalletContext';

/**
 * Listens for `app:wallet-limit` and shows linked wallets + current address.
 */
export default function WalletLimitModalHost() {
  const { account } = useWallet();
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const onLimit = (e) => {
      setInfo(e.detail || {});
      setOpen(true);
    };
    window.addEventListener('app:wallet-limit', onLimit);
    return () => window.removeEventListener('app:wallet-limit', onLimit);
  }, []);

  const wallets = Array.isArray(info?.wallets) ? info.wallets : [];
  const max = info?.max ?? 3;
  const current = info?.attempted || account;

  return (
    <Modal
      isOpen={open}
      onClose={() => setOpen(false)}
      title="Wallet link limit reached"
      size="md"
    >
      <div className="px-4 py-4 sm:px-6 sm:py-5 space-y-4 text-sm text-gray-700 dark:text-gray-300">
        <p>
          {info?.message ||
            `You can link at most ${max} wallets to this account. Keep using a linked wallet, or unlink one first.`}
        </p>

        {current ? (
          <div className="rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 px-3 py-2">
            <p className="text-[10px] font-bold uppercase tracking-wider text-amber-800 dark:text-amber-200 mb-1">
              Connected now
            </p>
            <p className="font-mono text-sm text-amber-950 dark:text-amber-100">
              {truncateAddress(current)}
            </p>
            <p className="text-xs text-amber-800/80 dark:text-amber-200/80 mt-1">
              This address was not linked because you are at the limit. You can still use it for
              browsing, but account actions that require a linked wallet need one of the addresses
              below.
            </p>
          </div>
        ) : null}

        <div>
          <p className="text-[10px] font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-2">
            Your linked wallets ({wallets.length}/{max})
          </p>
          {wallets.length > 0 ? (
            <ul className="space-y-2">
              {wallets.map((w) => (
                <li
                  key={w}
                  className="flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2 bg-gray-50 dark:bg-gray-900/50"
                >
                  <span className="font-mono text-sm text-gray-900 dark:text-white">
                    {truncateAddress(w)}
                  </span>
                  <span className="text-[10px] font-semibold uppercase text-emerald-600 dark:text-emerald-400">
                    Linked
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 dark:text-gray-400">No linked wallets found.</p>
          )}
        </div>

        <div className="flex justify-end pt-1">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700"
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
}
